import { render, staticRenderFns } from "./HomeworkExam.vue?vue&type=template&id=32d70c5a"
import script from "./HomeworkExam.vue?vue&type=script&lang=js"
export * from "./HomeworkExam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/b08365e4-b55a-4269-82b4-b5e5a1490008/workspace/hsylc_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32d70c5a')) {
      api.createRecord('32d70c5a', component.options)
    } else {
      api.reload('32d70c5a', component.options)
    }
    module.hot.accept("./HomeworkExam.vue?vue&type=template&id=32d70c5a", function () {
      api.rerender('32d70c5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sl/ApplicationCCL/Form/HomeworkExam.vue"
export default component.exports